import React, { useEffect, useState } from "react";
import Nav from "./Nav";
import arrowleft from "../assets/images/arrow-left.png";
import DropdownRight from "./DropdownRight";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import ReactInputMask from "react-input-mask";

function EditEvoPackageDetails(props) {

  const location = useLocation();
  const navigate = useNavigate();

  const { evoPackageId } = location.state;

  const token = GetStorage.get("xAuthToken");

  useEffect(() => {

    if (evoPackageId) {
      userGet();
    }
  }, []);

  const [error, setError] = useState("");
  const [evoPackageDetails, setEvoPackageDetails] = useState({});

  const userGet = () => {
    http
      .get(`api/admin/packages/${evoPackageId}?token=${token}`)
      .then((res) => {
        let packageDetails = res.data[0];
        packageDetails.price = parseFloat(packageDetails.price).toFixed(2);
        packageDetails.duration = parseFloat(packageDetails.duration).toFixed(2);

      setEvoPackageDetails(packageDetails);
        setEvoPackageDetails(res.data[0]);
      })
      .catch((error) => {
        console.log("error ", error.response.data.errors);
      });
  };
  


  const onSubmit = async (values) => {
    if (evoPackageDetails.id) {
      http
        .put(`api/admin/packages?token=${token}`, {
          id: evoPackageDetails.id,
          name: evoPackageDetails.name,
          sample: "https://argo-voice.s3.amazonaws.com/analyst-videos/practicsvideo.mp4",
          strokes_number: 1,
          delivery_time: evoPackageDetails.delivery_time,
          duration: parseFloat(evoPackageDetails.duration).toFixed(2),
          price: parseFloat(evoPackageDetails.price).toFixed(2),
          createdBy: 'admin'
        })
        .then((res) => {
          showToast("success", res.data.message);
          setTimeout(() => {
            navigate(-1);
          }, 3000);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.errors) {
              for (let key in error.response.data.errors) {
                setError(error.response.data.errors[key]);
                showToast("error", error.response.data.errors[key]);
              }
            } else if (error.response.data.message) {
              showToast("error", error.response.data.message);

              setError(error.response.data.message);
            }
          }
        });

    } else {
      http
        .post(`api/admin/packages?token=${token}`, {
          name: evoPackageDetails.name,
          sample: "https://argo-voice.s3.amazonaws.com/analyst-videos/practicsvideo.mp4",
          strokes_number: 1,
          delivery_time: evoPackageDetails.delivery_time,
          duration: parseFloat(evoPackageDetails.duration).toFixed(2),
          price: parseFloat(evoPackageDetails.price).toFixed(2),
          createdBy: 'admin'
        })
        .then((res) => {
          showToast("success", res.data.message);
          setTimeout(() => {
            navigate(-1);
          }, 3000);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.errors) {
              for (let key in error.response.data.errors) {
                setError(error.response.data.errors[key]);
                showToast("error", error.response.data.errors[key]);
              }
            } else if (error.response.data.message) {
              showToast("error", error.response.data.message);

              setError(error.response.data.message);
            }
          }
        });
    }

  };

  const onChangeProp = (event, key) => {
    evoPackageDetails[key] = event.target.value
    setEvoPackageDetails(evoPackageDetails);
  };


  return (
    <>
      <body>
        <div className="wrapper">
          <Nav />
          <div id="content">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  <button
                    onClick={() => navigate(-1)}
                    type="button"
                    id="sidebarCollapse"
                    className="btn btn-link  "
                  >
                    <img src={arrowleft} className="img-fluid" />{" "}
                  </button>
                  <h1>{evoPackageId != null && evoPackageId != undefined  ? "Edit Evo Package Details" : "Add Evo Package Details" }</h1>{" "}
                </div>
                <DropdownRight />
              </div>
            </header>

            <Formik
              initialValues={evoPackageDetails}
              onSubmit={onSubmit}>
              {({ values, handleSubmit, setFieldValue, handleChange }) => (
                <>
                  <div className="dashbord_content">
                    <div className="dashobord_inner new_team_add mt-5">
                      {/* <h5 className="my-3">General Info</h5> */}
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Evo Package Name</label>
                              <input
                                type="text"
                                id="name"
                                name="name"
                                onChange={(e) => {
                                  handleChange(e);
                                  onChangeProp(e, "name")
                                }}
                                value={evoPackageDetails.name}
                                placeholder="Enter Evo Package Name"
                                className="custom_input form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Duration (In Minutes)</label>
                              <input
                                type="text"
                                id="duration"
                                name="duration"
                                onChange={(e) => {
                                  handleChange(e);
                                  onChangeProp(e, "duration")
                                }}
                                value={evoPackageDetails.duration}
                                placeholder="Enter Duration"
                                className="custom_input form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Price (In USD)</label>
                              <input
                                type="text"
                                id="price"
                                name="price"
                                onChange={(e) => {
                                  handleChange(e);
                                  onChangeProp(e, "price")
                                }}
                                value={evoPackageDetails.price}
                                placeholder="Enter Price"
                                className="custom_input form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6">
                            <div className="fomr-group">
                              <label>Delivery Time (In Days)</label>
                              <input
                                type="text"
                                id="delivery_time"
                                name="delivery_time"
                                onChange={(e) => {
                                  handleChange(e);
                                  onChangeProp(e, "delivery_time")
                                }}
                                value={evoPackageDetails.delivery_time}
                                placeholder="Enter Delivery Time"
                                className="custom_input form-control"
                              />
                            </div>
                          </div>



                          <div className="col-12 d-flex justify-content-end">
                            <div className="btn_wraper d-flex Permissions_text align-item-center mt_40 mb_30">
                              <button
                                onClick={() => navigate(-1)}
                                type="button"
                                className=" them_btn_ouline  "
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="them_btn "
                                onClick={onSubmit}
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              )}
            </Formik>
          </div>
        </div>

        <div
          className="modal fade starrating new_team_add"
          id="new_team_add"
          data-backdrop="static"
          data-keyboard="false"
          tabindex="-1"
          aria-labelledby="new_team_add"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="new_team_add">
                  Super Admin Login
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  {" "}
                  <span aria-hidden="true">&times;</span>{" "}
                </button>
              </div>
              <div className="modal-body">
                <div className="raing_star">
                  <p>Please enter your login credentials to proceed.</p>
                  <div className="row mt-3">
                    <div className="col-12">
                      <div className="fomr-group">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email ID"
                        />{" "}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="fomr-group">
                        <input
                          type="Password"
                          className="form-control"
                          placeholder="Password"
                        />{" "}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer border-top-0">
                  <button type="button" className="them_btn_ouline ">
                    Cancel
                  </button>
                  <button type="button" className="them_btn ">
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
      <ToastContainer />
    </>
  );
}

export default EditEvoPackageDetails;
